import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { baseApiURL } from "../../baseUrl";
import { FaBed, FaUser, FaMailBulk, FaPhone, FaShieldAlt } from "react-icons/fa";

const HostelIncharge = () => {
  const [data, setData] = useState({
    hostelStaffId: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    role: "Chief Warden",
    gender: "",
  });

  const resetForm = () => {
    setData({
      hostelStaffId: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      role: "Chief Warden",
      gender: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!data.hostelStaffId || !data.firstName || !data.lastName || !data.email || !data.phoneNumber || !data.gender) {
      toast.error("Please fill in all fields");
      return;
    }
    const token = localStorage.getItem("token");
    toast.loading("Creating Hostel Incharge...");

    axios
      .post(`${baseApiURL()}/hostel/details/addDetails`, data, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        if (response.data.success) {
          axios
            .post(
              `${baseApiURL()}/hostel/auth/register`,
              {
                loginid: data.hostelStaffId,
                password: data.hostelStaffId,
              },
              { headers: { Authorization: `Bearer ${token}` } }
            )
            .then((res) => {
              toast.dismiss();
              if (res.data.success) {
                toast.success(`Hostel Warden registered with Login ID & Password: ${data.hostelStaffId}`);
                resetForm();
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              toast.dismiss();
              toast.error(error.response?.data?.message || "Unable to register credentials.");
            });
        } else {
          toast.dismiss();
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error(error.response?.data?.message || "Unable to save details.");
      });
  };

  return (
    <div className="w-full space-y-6">
      <div className="bg-white dark:bg-slate-900 rounded-2xl p-6 border border-slate-200 dark:border-slate-800 shadow-sm">
        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
          <div className="p-3 bg-gradient-to-br from-rose-500 to-amber-600 rounded-xl text-white shadow-md">
            <FaBed className="text-xl" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-slate-900 dark:text-slate-100">
              Hostel Warden / Incharge Management
            </h2>
            <p className="text-xs text-slate-500 dark:text-slate-400">
              Add new Hostel Wardens, Caretakers, and Staff accounts
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 max-w-2xl text-xs">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="font-bold text-slate-700 dark:text-slate-300">Staff / Warden ID</label>
              <input
                type="text"
                placeholder="e.g. WARDEN-01"
                value={data.hostelStaffId}
                onChange={(e) => setData({ ...data, hostelStaffId: e.target.value })}
                className="w-full mt-1 p-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700 font-mono"
              />
            </div>
            <div>
              <label className="font-bold text-slate-700 dark:text-slate-300">Role Designation</label>
              <select
                value={data.role}
                onChange={(e) => setData({ ...data, role: e.target.value })}
                className="w-full mt-1 p-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700"
              >
                <option value="Chief Warden">Chief Warden</option>
                <option value="Block Warden">Block Warden</option>
                <option value="Caretaker">Caretaker</option>
                <option value="Security Incharge">Security Incharge</option>
                <option value="Mess Manager">Mess Manager</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="font-bold text-slate-700 dark:text-slate-300">First Name</label>
              <input
                type="text"
                placeholder="First Name"
                value={data.firstName}
                onChange={(e) => setData({ ...data, firstName: e.target.value })}
                className="w-full mt-1 p-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700"
              />
            </div>
            <div>
              <label className="font-bold text-slate-700 dark:text-slate-300">Last Name</label>
              <input
                type="text"
                placeholder="Last Name"
                value={data.lastName}
                onChange={(e) => setData({ ...data, lastName: e.target.value })}
                className="w-full mt-1 p-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="font-bold text-slate-700 dark:text-slate-300">Email Address</label>
              <input
                type="email"
                placeholder="warden@college.edu"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value })}
                className="w-full mt-1 p-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700"
              />
            </div>
            <div>
              <label className="font-bold text-slate-700 dark:text-slate-300">Phone Number</label>
              <input
                type="number"
                placeholder="10-digit number"
                value={data.phoneNumber}
                onChange={(e) => setData({ ...data, phoneNumber: e.target.value })}
                className="w-full mt-1 p-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700"
              />
            </div>
          </div>

          <div>
            <label className="font-bold text-slate-700 dark:text-slate-300">Gender</label>
            <select
              value={data.gender}
              onChange={(e) => setData({ ...data, gender: e.target.value })}
              className="w-full mt-1 p-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700"
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="flex gap-2 pt-2">
            <button
              type="submit"
              className="px-5 py-2.5 rounded-xl text-xs font-bold bg-gradient-to-r from-rose-500 to-amber-600 text-white cursor-pointer hover:opacity-90 shadow-sm transition"
            >
              Save & Create Credentials
            </button>
            <button
              type="button"
              onClick={resetForm}
              className="px-4 py-2.5 rounded-xl text-xs font-bold border border-slate-200 dark:border-slate-700 cursor-pointer"
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default HostelIncharge;
